import { reviewsRoute } from './reviews';

export const allReviews = [
  reviewsRoute()
];
